import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";
import { getProps } from "./get-props";

import { EsportArticleView } from "./view";

type Params = { id: string; variant?: string; slug?: string };

export const EsportArticleController = () => {
    const { pathname: pagePath } = useLocation();
    const { trackPageView } = useSnowplowContext();

    const { id, variant, slug } = useParams<Params>();
    const isolated =
        (variant && variant.toLowerCase() === "isolated") ||
        (slug && slug.toLowerCase() === "isolated");

    const track = (article: any) => {
        trackPageView(article?.title ?? "", pagePath);
    };

    const props = {
        getProps: getProps(id!, !!isolated),
        id,
        track,
    };

    return <EsportArticleView {...props} />;
};
